import React, { useState } from "react";

export const StarRating = ({ data }) => {
  // const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  return (
    <div className="star-rating">
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={`text-4xl cursor-pointer ${
              index <= (hover || data.rating) ? "text-orange-500" : "text-t-bk"
            }`}
            onClick={() => data.setRating(index)}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(data.rating)}
          >
            <span className="star">&#9733;</span>
          </button>
        );
      })}
    </div>
  );
};
